/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc.
 * All Rights Reserved.
 */

import { createUpdatePromptService } from '../../../../common/prompt/createPromptV2Services';
import * as constants from '../../constants/ServiceConstants';
import { PROMPT_MANAGEMENT_LANG_KEYS } from '../../constants/StudioTextConstants';

export default createUpdatePromptService({
  eventName: constants.UPDATE_PROMPT,
  statusKey: 'updatePromptStatus',
  storeName: 'studioPromptModel',
  errorLangKey: PROMPT_MANAGEMENT_LANG_KEYS.ERROR_SAVE,
  errorEvent: constants.UPDATE_PROMPT_ERROR
});
